import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useResize } from 'src/hooks/useResize/useResize';
import styles from './Textbox.module.css';

export interface TextBoxProps {
    className: string;
    value: string;
    onChangeValue: (value: string) => void;
    maxLength?: number;
    disabled?: boolean;
    id?: string;
}

export function Textbox(props: TextBoxProps) {
    const { value, className, id, maxLength: maaLength, disabled, onChangeValue } = props;
    const ref = useRef<HTMLTextAreaElement>(null);
    const { t } = useTranslation();
    const size = useResize();
    const [heightState, setHeightState] = useState<number>(undefined);

    const autoSize = () => {
        const { style } = ref.current;
        if (!heightState) {
            style.height = '0px';
            const clientHeight = ref.current.clientHeight;
            setHeightState(clientHeight);
            style.height = '';
        } else {
            ref.current.style.height = '0px';
            const scrollHeight = ref.current.scrollHeight;
            const height = scrollHeight - heightState;
            if (height > heightState) {
                style.height = `${height}px`;
            } else {
                style.height = '';
            }
        }
    };

    useEffect(() => {
        autoSize();
    }, [size.width]);

    const textbox = () => {
        return (
            <textarea
                auto-id = {id}
                data-testid = 'textbox-id'
                className={`${styles} ${className}`}
                ref={ref}
                placeholder={t('SharedDesignAction.TextField.AddComment')}
                value={value}
                disabled={disabled}
                maxLength={maaLength}
                onChange={e => {
                    onChangeValue(e.target.value);
                    autoSize();
                }}></textarea>
        );
    };

    return textbox();
}
